import { SetStateAction, Dispatch, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { AppMessage, messageLevels, ToastMessage } from '@/types/appMessage';

export default function useAddMessage(setMessages: Dispatch<SetStateAction<ToastMessage[]>>) {
  return useCallback(
    (levelOrMessage: AppMessage['level'] | AppMessage | AppMessage[], text?: string) => {
      if (Array.isArray(levelOrMessage)) {
        return setMessages((currentMessages) => [
          ...currentMessages,
          ...levelOrMessage.map((message) => ({
            ...message,
            id: uuidv4()
          }))
        ]);
      }

      const messageId = uuidv4();

      if (text && typeof levelOrMessage === 'string' && messageLevels.includes(levelOrMessage)) {
        return setMessages((currentMessages) => [
          ...currentMessages,
          { id: messageId, level: levelOrMessage, text }
        ]);
      }

      if (
        typeof levelOrMessage === 'object' &&
        'level' in levelOrMessage &&
        'text' in levelOrMessage
      ) {
        return setMessages((currentMessages) => [
          ...currentMessages,
          { id: messageId, ...levelOrMessage }
        ]);
      }
    },
    [setMessages]
  );
}
